import type { Witness } from '../store/booksStore'
import type { SourceObject } from '../types/sourceObjects'

type SourceObjectIdentityInput = Partial<Pick<
  Witness,
  'sigla' | 'description' | 'library' | 'city' | 'shelfmark' | 'manuscript_date' | 'witness_type'
>>

const normalizeIdentityPart = (value?: string): string => (
  (value || '')
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim()
)

export const buildSourceObjectMatchKey = (input: SourceObjectIdentityInput): string | null => {
  const library = normalizeIdentityPart(input.library)
  const city = normalizeIdentityPart(input.city)
  const shelfmark = normalizeIdentityPart(input.shelfmark)

  if (!library || !city || !shelfmark) {
    return null
  }

  return `${library}::${city}::${shelfmark}`
}

export const buildSourceObjectCanonicalLabel = (input: SourceObjectIdentityInput): string => {
  const city = (input.city || '').trim()
  const shelfmark = (input.shelfmark || '').trim()
  const library = (input.library || '').trim()
  const description = (input.description || '').trim()
  const sigla = (input.sigla || '').trim()

  if (city && shelfmark) {
    return `${city} ${shelfmark}`.trim()
  }
  if (library && shelfmark) {
    return `${library} ${shelfmark}`.trim()
  }
  if (description) {
    return description
  }
  if (sigla) {
    return sigla
  }
  return 'Unlabeled source'
}

export const buildSourceObjectRecord = ({
  id,
  workId,
  input,
  createdAt
}: {
  id: string
  workId: string
  input: SourceObjectIdentityInput
  createdAt: number
}): SourceObject => ({
  id,
  work_id: workId,
  canonical_label: buildSourceObjectCanonicalLabel(input),
  description: input.description,
  library: input.library,
  city: input.city,
  shelfmark: input.shelfmark,
  manuscript_date: input.manuscript_date,
  source_type: input.witness_type,
  normalized_match_key: buildSourceObjectMatchKey(input) || undefined,
  created_at: createdAt,
  last_modified: createdAt,
  version: 1
})
